module.exports = __webpack_public_path__ + "static/img/school-6.908be4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/school-6.png
// module id = MCWC
// module chunks = 1